import React, { createContext, useContext, useState } from 'react';

const KbContext = createContext('kb_context');
const KBArticleContext = createContext('kb_article_context');
const KBArticleContextProvider = KBArticleContext.Provider;

export const KbProvider = ({ children }) => {
  const [expandedItems, setExpandedItems] = useState([]);
  const [treeItems, setTreeItems] = useState([]);
  const [activeViewConfig, setActiveViewConfig] = useState({});
  const [bulkRecord, setbulkRecord] = useState([]);
  const [filterConditions, setFilterConditions] = useState();
  const [loadingImportSummary, setLoadingImportSummary] = useState(false);
  const [showImportSummary, setShowImportSummary] = useState(false);

  const kbProviderValues = {
    activeViewConfig,
    setActiveViewConfig,
    treeItems,
    setTreeItems,
    expandedItems,
    setExpandedItems,
    bulkRecord,
    setbulkRecord,
    filterConditions,
    setFilterConditions,
    showImportSummary,
    setShowImportSummary,
    loadingImportSummary,
    setLoadingImportSummary
  };

  return (
    <KbContext.Provider value={kbProviderValues}>{children}</KbContext.Provider>
  );
};

export const useKbContext = () => {
  const context = useContext(KbContext);
  if (context === undefined) {
    throw new Error('useKbContext must be used within a KbProvider');
  }
  return context;
};

export { KBArticleContext, KBArticleContextProvider };
